export default __webpack_public_path__ + "static/banner_back-f9ff196b7fd1acbca1c99bf104ab146d.webp";